export const Policies = {
  CAN_TRIGGER_AUTOMATIC_JOB: "TriggerAutomaticJob",

  CAN_EDIT_SYSTEM_USERS: "EditSystemUsers",
  CAN_READ_SYSTEM_USERS: "ReadSystemUsers",

  CAN_READ_OPERATOR_DATA: "ReadOperators",
  CAN_EDIT_OPERATOR_DATA: "EditOperators",

  CAN_IMPORT_SYSTEM_DATA: "ImportSystemData",

  CAN_READ_CUSTOMER_DATA: "ReadCustomers",
  CAN_EDIT_CUSTOMER_DATA: "EditCustomers",
  CAN_ROTATE_CUSTOMER_API_KEYS: "RotateCustomerApiKeys",
  CAN_DELETE_CUSTOMER_API_KEYS: "DeleteCustomerApiKeys",

  CAN_READ_ISSUER_DATA: "ReadIssuers",
  CAN_EDIT_ISSUER_DATA: "EditIssuers",

  CAN_READ_CARD_DATA: "ReadCards",
  CAN_EDIT_CARD_DATA: "EditCards",

  CAN_READ_REPORTS: "ReadReports",
  CAN_EDIT_REPORTS: "EditReports",
  CAN_DOWNLOAD_REPORTS: "DownloadReports",

  CAN_READ_SEPA: "ReadSepa",
  CAN_EDIT_SEPA: "EditSepa",
  CAN_DOWNLOAD_SEPA: "DownloadSepa",

  CAN_READ_ACCOUNT_USERS: "ReadUsers",
  CAN_EDIT_ACCOUNT_USERS: "EditUsers",

  CAN_READ_ACCOUNT_DATA: "ReadAccounts",
  CAN_EDIT_ACCOUNT_DATA: "EditAccounts",

  CAN_READ_ACCOUNT_GROUP_DATA: "ReadAccountGroups",
  CAN_EDIT_ACCOUNT_GROUP_DATA: "EditAccountGroups",

  CAN_TRANSFER_ACCOUNT_VALUES: "TransferAccountValues",
  CAN_CORRECT_ACCOUNT_VALUES: "CorrectAccountValues",

  CAN_READ_DEVICE_DATA: "ReadDevices",
  CAN_EDIT_DEVICE_DATA: "EditDevices",

  CAN_READ_ISSUER_SEPA_SETTINGS: "ReadIssuerSepaSettings",
  CAN_EDIT_ISSUER_SEPA_SETTINGS: "EditIssuerSepaSettings",

  CAN_READ_CUSTOMER_SEPA_SETTINGS: "ReadCustomerSepaSettings",
  CAN_EDIT_CUSTOMER_SEPA_SETTINGS: "EditCustomerSepaSettings",

  CAN_READ_ACCOUNT_LIMIT_SETTINGS: "ReadAccountLimitSettings",
  CAN_EDIT_ACCOUNT_LIMIT_SETTINGS: "EditAccountLimitSettings",

  CAN_READ_ISSUER_WEBCHARGE_SETTINGS: "ReadIssuerWebChargeSettings",
  CAN_EDIT_ISSUER_WEBCHARGE_SETTINGS: "EditIssuerWebChargeSettings",

  CAN_READ_GRATIFICATION_SETTINGS: "ReadGratificationSettings",
  CAN_EDIT_GRATIFICATION_SETTINGS: "EditGratificationSettings",

  CAN_READ_VAT_DETAILS: "ReadVatDetails",
  CAN_EDIT_VAT_DETAILS: "EditVatDetails",

  CAN_RESET_ACCOUNT_USER_PASSWORDS: "ResetAccountUserPasswords",
  CAN_RESET_CUSTOMER_PASSWORDS: "ResetCustomerPasswords",

  CAN_READ_SCHEDULER_JOB_STATES: "ReadSchedulerJobStates",
} as const;
